import { Charge } from "./charge.model";
import { Location } from "./location.model";
import { VehicleType } from "./vehicletype.model";
import { PromotionType } from "./promotiontype.model";
import { AgeRange } from "./agerange.model";
import { OTA_VehAvail } from "./ota_vehavail.model";
import { RentingEntity } from "./rentingentity.model";
import { OTA_VehRetResRS } from "./ota_vehretresrs.model";

export enum enumBusinessEventMode {
    beMode_Unknown = 0,
    beMode_Create = 1,
    beMode_Edit = 2,
    beMode_View = 3,
}

export enum enumBusinessEventAction {
    beAction_Unknown = 0,
    beAction_Create = 1,
    beAction_Update = 2,
    beAction_Cancel = 3,
}

export class BusinessEvent {
    public reference: string;
    public chargeList = new Array<Charge>();
    public vehicleType = new VehicleType();
    public promotionType = new PromotionType();
    public locationOut = new Location();
    public locationIn = new Location();
    public dateTimeOut?: Date;
    public dateTimeIn?: Date;
    public ageRange = new AgeRange();
    public promoCode: string;
    public vehicleGroupReserved: string;
    public flightNumber: string;
    public vehicleSelected: boolean = false;
    public otaVehAvail = new OTA_VehAvail();
    public rentingentity = new RentingEntity();
    public hasDelivery: boolean = false;
    public deliveryAddress: string;
    public hasCollection: boolean = false;
    public collectionAddress: string;
    public payNow: boolean = false;

    public refresh: boolean = false;

    public eventMode: enumBusinessEventMode = enumBusinessEventMode.beMode_Create;
    public eventAction: enumBusinessEventAction = enumBusinessEventAction.beAction_Unknown;
    public otaVehRetResRS = new OTA_VehRetResRS();
    public rentalChanged: boolean = false;
}